import type { AuthSession } from './session';

export const LOGIN_PATH = '/login';
export const REGISTER_PATH = '/register';
export const FORGOT_PASSWORD_PATH = '/recover-password';
export const RESET_PASSWORD_PATH = '/forgot-password';
export const DASHBOARD_PATH = '/dashboard';
export const CALENDAR_PATH = '/calendar';
export const ANALYTICS_PATH = '/analytics';
export const CLIENTS_PATH = '/clients';
export const BUSINESS_SETTINGS_PATH = '/settings/business';
export const PERSONAL_SETTINGS_PATH = '/settings/personal';
export const SERVICES_SETTINGS_PATH = '/settings/services';
export const SPACES_SETTINGS_PATH = '/settings/spaces';
export const STAFF_SETTINGS_PATH = '/settings/staff';
export const AVAILABILITY_SETTINGS_PATH = '/settings/availability';
export const ONBOARDING_PATH = '/onboarding';

export function resolveAuthenticatedPath(
  session: Pick<AuthSession, 'hasBusiness'>,
  intendedPath?: string
) {
  if (!session.hasBusiness) {
    return ONBOARDING_PATH;
  }

  if (
    intendedPath &&
    intendedPath !== LOGIN_PATH &&
    intendedPath !== REGISTER_PATH &&
    intendedPath !== ONBOARDING_PATH
  ) {
    return intendedPath;
  }

  return DASHBOARD_PATH;
}
